import ColorPricingCategorySelectFilter from "../../../shared/table/ColorPricingCategorySelectFilter";
import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
  {
    Header: "Name",
    accessor: "name",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Hyphanate Name",
    accessor: "hyphanateName",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "PPC Feed Name",
    accessor: "ppcName",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Product Examples",
    accessor: "productExamples",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Colors Max",
    accessor: "colorsMax",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Pricing Type",
    accessor: "pricingType",
    optionLabelField: "pricingType",
    optionValueField: "pricingType",
    Filter: ColorPricingCategorySelectFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
